import axios from 'axios'
import initAxios from '~/vuestrap/axios'

initAxios(axios)

export default axios
